import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, User, Building2, Mail, Shield } from 'lucide-react';

export default function MobileProfile() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/landing');
    };

    const initials = (user?.name || '').split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

    return (
        <div className="px-5 pt-[calc(1.5rem+env(safe-area-inset-top))] pb-6" data-testid="mobile-profile">
            <h1 className="text-xl font-bold text-gray-900 mb-6">Mon profil</h1>

            {/* Avatar + Name */}
            <div className="flex flex-col items-center mb-8">
                <div className="w-20 h-20 rounded-full bg-[#6366F1]/10 flex items-center justify-center mb-3">
                    <span className="text-2xl font-bold text-[#6366F1]">{initials}</span>
                </div>
                <p className="text-lg font-semibold text-gray-900">{user?.name}</p>
                {user?.agency_name && <p className="text-sm text-gray-400 mt-0.5">{user.agency_name}</p>}
            </div>

            {/* Info cards */}
            <div className="space-y-2 mb-8">
                <InfoRow icon={User} label="Nom" value={user?.name} />
                <InfoRow icon={Mail} label="Email" value={user?.email} />
                <InfoRow icon={Shield} label="Rôle" value="Commercial" />
                {user?.agency_name && <InfoRow icon={Building2} label="Agence" value={user.agency_name} />}
            </div>

            {/* Logout */}
            <button
                onClick={handleLogout}
                className="w-full bg-white rounded-2xl p-4 flex items-center justify-center gap-2.5 border border-red-100 text-red-600 font-medium text-[14px] active:scale-[0.98] transition-transform shadow-sm"
                data-testid="mobile-logout-btn"
            >
                <LogOut className="w-5 h-5" />
                Déconnexion
            </button>
        </div>
    );
}

function InfoRow({ icon: Icon, label, value }) {
    return (
        <div className="bg-white rounded-xl p-3.5 flex items-center gap-3 shadow-sm border border-gray-100">
            <div className="w-9 h-9 rounded-lg bg-gray-50 flex items-center justify-center shrink-0">
                <Icon className="w-4 h-4 text-gray-400" strokeWidth={1.5} />
            </div>
            <div className="min-w-0">
                <p className="text-[11px] text-gray-400 uppercase tracking-wider">{label}</p>
                <p className="text-[13px] text-gray-900 font-medium truncate">{value}</p>
            </div>
        </div>
    );
}
